import { SERVICE_URL } from '@/store/_commons';
import { load } from 'recaptcha-v3';

// To.Be.Replaced - this content should replace that of recaptcha.js once everything else has been refactored

function getRecaptchaTokenTBR(action) {
  return new Promise((resolve, reject) => {
    load(window.config.RECAPTCHA_SITE_KEY).then((recaptcha) => {
      recaptcha.execute(action)
        .then((token) => {
          return resolve(token);
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    });
  });
}

async function getReCaptchaHeaderTBR(method, endpoint) {
  if (!method || !endpoint) {
    return {};
  }
  const action = `${ method }_${ endpoint.replace(SERVICE_URL, '').split('/').join('_') }`;
  const token = await getRecaptchaTokenTBR(action);

  return {
    headers: {
      'Recaptcha': token
    }
  };
}

export default getReCaptchaHeaderTBR;
